import { render, staticRenderFns } from "./CashFlowStatementQuarter.vue?vue&type=template&id=baafe892&scoped=true"
import script from "./CashFlowStatementQuarter.vue?vue&type=script&lang=js"
export * from "./CashFlowStatementQuarter.vue?vue&type=script&lang=js"
import style0 from "./CashFlowStatementQuarter.vue?vue&type=style&index=0&id=baafe892&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baafe892",
  null
  
)

export default component.exports